import React, { useEffect, useState } from 'react';
import { useApi } from '../api';
import {
  Table, TableBody, TableCell, TableHead, TableRow, TableContainer,
  Paper, Typography, Button, Modal, Box, TextField, IconButton,
  Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
  Card, useMediaQuery, useTheme
} from '@mui/material';
import { Delete, Edit, PersonAdd } from '@mui/icons-material';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import { motion } from 'framer-motion';
import Tooltip from '@mui/material/Tooltip';
import CloseIcon from '@mui/icons-material/Close';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import EditIcon from '@mui/icons-material/Edit';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';




const modalStyle = {
  position: 'absolute',
  top: '50%', left: '50%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: 'white',
  padding: 4,
  borderRadius: 2,
  boxShadow: 24,
  width: 400,
};

const Clientes = () => {
  const [clientes, setClientes] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modoEdicion, setModoEdicion] = useState(false);
  const [clienteActual, setClienteActual] = useState(null);
  const [nuevoCliente, setNuevoCliente] = useState({
    nombre: '', cedula: '', telefono: '', correo: '', direccion: ''
  });
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [clienteAEliminar, setClienteAEliminar] = useState(null);
  const [errorFormulario, setErrorFormulario] = useState('');
  const [busqueda, setBusqueda] = useState('');
  const api = useApi();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const clientesFiltrados = clientes.filter((cliente) => {
    const termino = busqueda.trim().toLowerCase();
    if (!termino) return true;
    return [cliente.nombre, cliente.cedula, cliente.telefono, cliente.correo, cliente.direccion]
      .some((campo) => (campo || '').toLowerCase().includes(termino));
  });


  

  const fetchClientes = async () => {
    try {
      const response = await api.get(`${process.env.REACT_APP_API_URL}/api/clientes/`);
      setClientes(response.data);
    } catch (err) {
      console.error('Error al cargar clientes', err);
    }
  };

  useEffect(() => {
    fetchClientes();
  }, []);

  const handleChange = (e) => {
    setNuevoCliente({ ...nuevoCliente, [e.target.name]: e.target.value });
  };

const handleSubmit = async () => {
  setErrorFormulario({});
  try {
    if (modoEdicion && clienteActual) {
      await api.put(`${process.env.REACT_APP_API_URL}/api/clientes/${clienteActual.id}/`, nuevoCliente);
    } else {
      await api.post(`${process.env.REACT_APP_API_URL}/api/clientes/`, nuevoCliente);
    }
    cerrarModal();
    fetchClientes();
  } catch (err) {
    if (err.response && err.response.status === 400) {
      // <-- Cambia aquí:
      const data = err.response.data;
      // Convierte el array de errores de cada campo en string
      const erroresPorCampo = {};
      Object.entries(data).forEach(([campo, errores]) => {
        erroresPorCampo[campo] = errores.join(', ');
      });
      setErrorFormulario(erroresPorCampo);
    } else {
      console.error('Error inesperado:', err);
      setErrorFormulario({ global: 'Error inesperado al guardar cliente.' });
    }
  }
};


  const abrirModalEdicion = (cliente) => {
    setModoEdicion(true);
    setClienteActual(cliente);
    setNuevoCliente({
      nombre: cliente.nombre,
      cedula: cliente.cedula,
      telefono: cliente.telefono,
      correo: cliente.correo,
      direccion: cliente.direccion
    });
    setModalOpen(true);
  };

  const abrirModalCreacion = () => {
    setModoEdicion(false);
    setClienteActual(null);
    setNuevoCliente({ nombre: '', cedula: '', telefono: '', correo: '', direccion: '' });
    setModalOpen(true);
  };

  const cerrarModal = () => {
    setModalOpen(false);
  };

  const confirmarEliminar = (cliente) => {
    setClienteAEliminar(cliente);
    setConfirmOpen(true);
  };

  const eliminarCliente = async () => {
    try {
      await api.delete(`${process.env.REACT_APP_API_URL}/api/clientes/${clienteAEliminar.id}/`);
      setConfirmOpen(false);
      setClienteAEliminar(null);
      fetchClientes();
    } catch (err) {
      console.error('Error al eliminar cliente', err);
    }
  };

  return (
      <Paper sx={{ padding: 2 }}>
      <div className="encabezado-app"
        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}
        as={motion.div}
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 2, ease: [0.6, 0.01, 0.05, 0.95] }}
      >
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.6, 0.01, 0.05, 0.95] }}
          >
            <Typography className="titulo-app" variant="h5" gutterBottom>
              <PeopleAltIcon sx={{ mr: 1, fontSize: 32, color: '#083a94', verticalAlign: 'middle' }} />
              Lista de Clientes
            </Typography>
          </motion.div>
        <motion.div
          whileHover={{ scale: 1.07, boxShadow: "0 4px 20px #1976d244" }}
          transition={{ type: "spring", stiffness: 400, damping: 15 }}
          style={{ display: 'inline-block' }}
        >
          <Button
            variant="contained"
            className="btn-app"
            startIcon={<PersonAdd />}
            onClick={abrirModalCreacion}
          >
            Agregar cliente
          </Button>
        </motion.div>
      </div>

      <TextField
        label="Buscar cliente"
        placeholder="Nombre, cédula, teléfono, correo o dirección..."
        size="small"
        fullWidth
        value={busqueda}
        onChange={(e) => setBusqueda(e.target.value)}
        sx={{ mb: 2 }}
      />

      {isMobile ? (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          {clientesFiltrados.map((cliente) => (
            <Card key={cliente.id} variant="outlined" sx={{ p: 2 }}>
              <Typography sx={{ fontWeight: 700 }}>{cliente.nombre}</Typography>
              <Typography variant="body2" color="text.secondary">Cédula: {cliente.cedula}</Typography>
              <Typography variant="body2" color="text.secondary">Tel: {cliente.telefono}</Typography>
              <Typography variant="body2" color="text.secondary">{cliente.correo}</Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>{cliente.direccion}</Typography>
              <Box sx={{ display: 'flex', gap: 0.5 }}>
                <Tooltip title="Editar" arrow>
                  <IconButton onClick={() => abrirModalEdicion(cliente)} sx={{ color: '#616161' }}>
                    <Edit />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Eliminar" arrow>
                  <IconButton color="error" onClick={() => confirmarEliminar(cliente)}>
                    <Delete />
                  </IconButton>
                </Tooltip>
              </Box>
            </Card>
          ))}
        </Box>
      ) : (
      <TableContainer sx={{ overflowX: 'auto' }}>
      <Table className="tabla-app">
        <TableHead>
          <TableRow>
            <TableCell>Nombre</TableCell>
            <TableCell>Cédula</TableCell>
            <TableCell>Teléfono</TableCell>
            <TableCell>Correo</TableCell>
            <TableCell>Dirección</TableCell>
            <TableCell>Acciones</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {clientesFiltrados.map((cliente) => (
                <motion.tr
                  key={cliente.id}
                  whileHover={{ scale: 1.01, boxShadow: "0 2px 16px #083a9422" }}
                  transition={{ type: "spring", stiffness: 300, damping: 22 }}
                >
              <TableCell>{cliente.nombre}</TableCell>
              <TableCell>{cliente.cedula}</TableCell>
              <TableCell>{cliente.telefono}</TableCell>
              <TableCell>{cliente.correo}</TableCell>
              <TableCell>{cliente.direccion}</TableCell>
              <TableCell>
                <Tooltip title="Editar" arrow>
                <IconButton
                  onClick={() => abrirModalEdicion(cliente)}
                  sx={{ color: '#616161', transition: 'color 0.2s' }}
                  onMouseEnter={e => e.currentTarget.style.color = '#083a94'}
                  onMouseLeave={e => e.currentTarget.style.color = '#616161'}
                >
                  <Edit />
                </IconButton>
                 </Tooltip>
                 <Tooltip title="Eliminar" arrow>
                <IconButton
                  color="error"
                  onClick={() => confirmarEliminar(cliente)}
                  sx={{ transition: 'transform 0.18s' }}
                  whileHover={{ scale: 1.15 }}
                >
                  <Delete />
                </IconButton>
                </Tooltip>

              </TableCell>
            </motion.tr>
          ))}
        </TableBody>
      </Table>
      </TableContainer>
      )}

      {/* Modal Crear/Editar */}
<Modal open={modalOpen} onClose={cerrarModal}>
  <Box className="modal-app" sx={{ ...modalStyle, position: 'relative' }}>
    {/* Botón de cerrar */}
    <IconButton
      aria-label="Cerrar"
      onClick={cerrarModal}
      sx={{ position: 'absolute', right: 16, top: 16, color: '#888' }}
    >
      <CloseIcon />
    </IconButton>
    {/* Encabezado */}
    <Box display="flex" alignItems="center" mb={2}>
      {modoEdicion
        ? <EditIcon color="primary" sx={{ fontSize: 32, mr: 1 }} />
        : <PersonAddIcon color="primary" sx={{ fontSize: 32, mr: 1 }} />
      }
      <Typography variant="h6" sx={{ fontWeight: 700 }}>
        {modoEdicion ? 'Editar Cliente' : 'Nuevo Cliente'}
      </Typography>
    </Box>
    {/* Formulario */}
    <form autoComplete="off" onSubmit={e => { e.preventDefault(); handleSubmit(); }}>
      <TextField label="Nombre" name="nombre" value={nuevoCliente.nombre} fullWidth margin="normal" onChange={handleChange} autoFocus error={!!errorFormulario.nombre} helperText={errorFormulario.nombre}/>
          <TextField label="Cédula" name="cedula" value={nuevoCliente.cedula} fullWidth margin="dense" onChange={handleChange}  error={!!errorFormulario.cedula} helperText={errorFormulario.cedula}/>
          <TextField label="Teléfono" name="telefono" value={nuevoCliente.telefono} fullWidth margin="dense" onChange={handleChange}  error={!!errorFormulario.telefono} helperText={errorFormulario.telefono}/>
          <TextField label="Correo" name="correo" value={nuevoCliente.correo} fullWidth margin="dense" onChange={handleChange}  error={!!errorFormulario.correo} helperText={errorFormulario.correo}/>
          <TextField label="Dirección" name="direccion" value={nuevoCliente.direccion} fullWidth margin="dense" onChange={handleChange}  error={!!errorFormulario.direccion} helperText={errorFormulario.direccion}/>
          <Button onClick={handleSubmit} variant="contained" sx={{ mt: 2 }}>
            {modoEdicion ? 'Actualizar' : 'Guardar'}
          </Button>
          </form>
        </Box>        
      </Modal>

      {/* Confirmación de Eliminación */}
      <Dialog
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
      >
        <DialogTitle className="dialog-title-alert">
          <WarningAmberIcon sx={{ fontSize: 28 }} />
          ¿Eliminar Cliente?
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Esta acción no se puede deshacer.<br />
            ¿Seguro que deseas eliminar a <strong>{clienteAEliminar?.nombre}</strong>?
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-actions-custom">
          <Button
            onClick={() => setConfirmOpen(false)}
            className="dialog-btn-cancel"
          >
            Cancelar
          </Button>
          <Button
            onClick={eliminarCliente}
            variant="contained"
            className="dialog-btn-delete"
          >
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
};

export default Clientes;
